const onFailure = (error) => ({
  message: 'Local já cadastrado!',
  type: 'warning',
});

export default onFailure;
